// Constant

// Components
import TableEmployee from "../TableEmployee";

export const TableItems = (
  filteredDataCount,
  employee,
  filteredData,
  paginatedData,
  tabKey,
  setFilteredData,
  selectedRow,
  setSelectedRow,
  isFiltered,
  setIsModalOpen,
  isLoad
) => {
  return [
    {
      label: `All (${filteredDataCount["all"]})`,
      key: "all",
      children: (
        <TableEmployee
          source={employee}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          isFiltered={isFiltered}
          setIsModalOpen={setIsModalOpen}
          isLoad={isLoad}
        />
      ),
    },
    {
      label: `Created (${filteredDataCount[1]})`,
      key: 1,
      children: (
        <TableEmployee
          source={employee}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          isFiltered={isFiltered}
          setIsModalOpen={setIsModalOpen}
          isLoad={isLoad}
        />
      ),
    },
    {
      label: `Active (${filteredDataCount[2]})`,
      key: 2,
      children: (
        <TableEmployee
          source={employee}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          isFiltered={isFiltered}
          setIsModalOpen={setIsModalOpen}
          isLoad={isLoad}
        />
      ),
    },
    {
      label: `Suspended (${filteredDataCount[3]})`,
      key: 3,
      children: (
        <TableEmployee
          source={employee}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          isFiltered={isFiltered}
          setIsModalOpen={setIsModalOpen}
          isLoad={isLoad}
        />
      ),
    },
    {
      label: `Terminated (${filteredDataCount[0]})`,
      key: 0,
      children: (
        <TableEmployee
          source={employee}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          isFiltered={isFiltered}
          isLoad={isLoad}
        />
      ),
    },
  ];
};
